<div class="fan-news-dialog">
  <div class="fan-news-dialog-header">
    <span class="fan-news-dialog-title">{{ story?.title }}</span>
    <button type="button" class="fan-news-icon-btn" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <iframe *ngIf="story && storyUrl" class="fan-news-frame" [src]="storyUrl" [title]="story.title"
    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    referrerpolicy="no-referrer"></iframe>

  <div class="fan-news-dialog-footer" *ngIf="story">Source: {{ story.sourceName || 'uReport' }} · uReport</div>
</div>
